"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpanLinkModalState = void 0;
const tslib_1 = require("tslib");
const core_shared_1 = require("@ikegps/core-shared");
const mobx_1 = require("mobx");
const i18n_1 = require("../../i18n");
/**
 * MobX state management for the span link modal.
 */
class SpanLinkModalState {
    constructor() {
        this.targetCollection = null;
        this.sourceCollection = null;
        this.sourceSpanInstanceId = null;
        this.selectedSpanId = null;
        this.createNewSpan = false;
    }
    /**
     * Determine which spans should be shown in the selection list.
     *
     * Logic:
     * 1. If any span on target already links TO source, show ONLY that span
     *    (user is updating an existing two-way link)
     * 2. Otherwise, show all unlinked spans (spanTargetCollectionId is null)
     */
    get availableSpans() {
        var _a, _b, _c;
        if (!this.targetCollection || !this.sourceCollection)
            return [];
        const allSpans = (_c = (_b = (_a = this.targetCollection) === null || _a === void 0 ? void 0 : _a.spanSubForm) === null || _b === void 0 ? void 0 : _b.value.map((instance) => new core_shared_1.SpanSubFormAdaptor(instance))) !== null && _c !== void 0 ? _c : [];
        const sourceCollectionId = this.sourceCollection.id;
        // Check if any span already links to source
        const spanLinkingToSource = allSpans.find((span) => span.spanTargetCollectionId === sourceCollectionId);
        let filteredSpans;
        if (spanLinkingToSource) {
            // If target has span linking to source, that's the ONLY option
            filteredSpans = [spanLinkingToSource];
        }
        else {
            // Return all unlinked spans
            filteredSpans = allSpans.filter((span) => !span.spanTargetCollectionId);
        }
        return filteredSpans.map((adaptor) => ({
            instanceId: adaptor.instance.instanceId,
            title: adaptor.instance.formTitle || adaptor.instance.title || (0, i18n_1.Translate)(i18n_1.T.SPAN),
            spanType: adaptor.spanTypeField.displayValue,
            color: core_shared_1.FormModelFieldSubForm.getSpanColor(adaptor.instance),
            isLinkedToSource: adaptor.spanTargetCollectionId === sourceCollectionId,
            adaptor,
        }));
    }
    /**
     * Check if the target already has a span linking to source
     */
    get hasExistingLinkToSource() {
        return this.availableSpans.some((item) => item.isLinkedToSource);
    }
    get selectedSpan() {
        var _a;
        if (!this.selectedSpanId)
            return null;
        return (_a = this.availableSpans.find((item) => item.instanceId === this.selectedSpanId)) !== null && _a !== void 0 ? _a : null;
    }
    get selectedSpanInstance() {
        var _a;
        if (!this.selectedSpanId || !((_a = this.targetCollection) === null || _a === void 0 ? void 0 : _a.spanSubForm))
            return null;
        return this.targetCollection.spanSubForm.getInstance(this.selectedSpanId);
    }
    get canSubmit() {
        return this.createNewSpan || this.selectedSpanId != null;
    }
    initialize(sourceCollection, targetCollection, sourceSpanInstanceId) {
        this.sourceCollection = sourceCollection;
        this.targetCollection = targetCollection;
        this.sourceSpanInstanceId = sourceSpanInstanceId;
        this.selectedSpanId = null;
        this.createNewSpan = false;
        // Auto-select if there's only one option (existing link to source)
        if (this.hasExistingLinkToSource && this.availableSpans.length === 1) {
            this.selectedSpanId = this.availableSpans[0].instanceId;
        }
    }
    selectSpan(instanceId) {
        this.selectedSpanId = instanceId;
        this.createNewSpan = false;
    }
    selectCreateNew() {
        this.selectedSpanId = null;
        this.createNewSpan = true;
    }
    reset() {
        this.targetCollection = null;
        this.sourceCollection = null;
        this.sourceSpanInstanceId = null;
        this.selectedSpanId = null;
        this.createNewSpan = false;
    }
}
exports.SpanLinkModalState = SpanLinkModalState;
tslib_1.__decorate([
    mobx_1.observable
], SpanLinkModalState.prototype, "targetCollection", void 0);
tslib_1.__decorate([
    mobx_1.observable
], SpanLinkModalState.prototype, "sourceCollection", void 0);
tslib_1.__decorate([
    mobx_1.observable
], SpanLinkModalState.prototype, "sourceSpanInstanceId", void 0);
tslib_1.__decorate([
    mobx_1.observable
], SpanLinkModalState.prototype, "selectedSpanId", void 0);
tslib_1.__decorate([
    mobx_1.observable
], SpanLinkModalState.prototype, "createNewSpan", void 0);
tslib_1.__decorate([
    mobx_1.computed
], SpanLinkModalState.prototype, "availableSpans", null);
tslib_1.__decorate([
    mobx_1.computed
], SpanLinkModalState.prototype, "hasExistingLinkToSource", null);
tslib_1.__decorate([
    mobx_1.computed
], SpanLinkModalState.prototype, "selectedSpan", null);
tslib_1.__decorate([
    mobx_1.computed
], SpanLinkModalState.prototype, "selectedSpanInstance", null);
tslib_1.__decorate([
    mobx_1.computed
], SpanLinkModalState.prototype, "canSubmit", null);
tslib_1.__decorate([
    mobx_1.action
], SpanLinkModalState.prototype, "initialize", null);
tslib_1.__decorate([
    mobx_1.action
], SpanLinkModalState.prototype, "selectSpan", null);
tslib_1.__decorate([
    mobx_1.action
], SpanLinkModalState.prototype, "selectCreateNew", null);
tslib_1.__decorate([
    mobx_1.action
], SpanLinkModalState.prototype, "reset", null);
//# sourceMappingURL=span.link.modal.state.js.map